;(function (Rewards, $) {

  var $dom = {};

  var cacheDom = () => {
    $dom.window = $(window);
    $dom.body = $('body');
    $dom.questions = $('.question');
    $dom.answers = $('.answer');
    $dom.upSlider = $('.rewards__levelup-options');
    $dom.seeMore = $('.icon-scroll-prompt a');
    $dom.learnMore = $('.rewards__earning-options h6 a');
    $dom.countdown = $('.countdown-banner');
    $dom.header = $('.main-header-wrapper');
  };

  var initUpSlider = () => {
    $dom.upSlider.slick({
      dots: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      variableWidth: true,
      centerMode: true,
      arrows: true,
      prevArrow: $('.prev_arrow'),
      nextArrow: $('.next_arrow'),
      mobileFirst: true,
      responsive: [
        {
           breakpoint: 810,
           settings: "unslick"
        }
      ]
    });
  };

  var getBodyHeightFromTop = function () {
    return $dom.body.offset().top + parseInt($dom.body.css('padding-top').slice(0, -2), 10);
  };

  var getHeaderHeight = function () {
    return $dom.header.height();
  };

  var scrollToElement = e => {
    var offset = getHeaderHeight()+getBodyHeightFromTop()-41;
    var mobileOffset = -10;

    if($dom.window.width() < 992){
      offset = offset - mobileOffset;
    }
    e.preventDefault();
    var target = $($(e.currentTarget).attr('href'));
    $('html,body').animate({
      scrollTop: target.offset().top - offset
    }, 1000);
    return false;
  };

  var bindUIActions = () => {
    $dom.questions.on('click', function (event) {
      var currentState = $(this).hasClass('active');
      $dom.answers.slideUp();
      $dom.questions.removeClass('active');
      $('.question .control').css({
        'transform': 'rotate(0)',
        'right': '19px'
      });
      if(currentState){
        $(this).removeClass('active');
        $(this).find('.answer').slideUp("slow");
        $(this).find('.control').css({
          'transform': 'rotate(0)',
          'right': '19px'
        });
      } else {
        $(this).addClass('active');
        $(this).find('.answer').slideDown("slow");
        $(this).find('.control').css({
          'transform': 'rotate(45deg)',
          'right': '16px'
        })
      }
    });

    $dom.window.resize( () => {
      if($dom.window.width() < 812 && !$('#rewards__levelup-options').hasClass('slick-initialized')){
        initUpSlider();
      }
    });

    $dom.seeMore.click( e => {
      scrollToElement(e);
    });

    $dom.learnMore.click( e => {
      scrollToElement(e);
    });
  };

  var initControls = () => {
    $dom.questions.append('<span class="control">+</span>');
  };

  Rewards.init = () => {
    cacheDom();
    bindUIActions();
    initControls();
    initUpSlider();
  };

}(window.Rewards = window.Rewards || {}, jQuery));
